import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeDropdownComponent } from './tree-dropdown.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from '@purespectrum1/ui/button';
import { SearchFilterPipeModule } from '../../pipes/filter-pipe.module';

@NgModule({
  declarations: [TreeDropdownComponent],
  imports: [
    CommonModule,
    ButtonModule,
    ReactiveFormsModule,
    SearchFilterPipeModule,
  ],
  exports: [TreeDropdownComponent],
})
export class TreeDropdownModule {}
